import { STAFF_OR_ABOVE } from "@excel-center/shared";
import i18next from "i18next";
import { AccountSection } from "@/src/settings/sections/account.section";
import { McpSection } from "@/src/settings/sections/mcp.section";
import { registerSettingsSection } from "@/src/settings/settings-sections.registry";

let bootstrapped = false;

function bootstrap(): void {
	if (bootstrapped) return;
	bootstrapped = true;

	registerSettingsSection({
		id: "account",
		order: 0,
		roles: [...STAFF_OR_ABOVE],
		title: i18next.t("common:settings.account.title"),
		description: i18next.t("common:settings.account.description"),
		component: AccountSection,
	});

	registerSettingsSection({
		id: "mcp",
		order: 10,
		roles: [...STAFF_OR_ABOVE],
		title: i18next.t("common:settings.mcp.title"),
		description: i18next.t("common:settings.mcp.description"),
		component: McpSection,
	});
}

bootstrap();
